import { useQuery, useMutation, useQueryClient } from 'react-query';
import { apiClient } from '../services/apiClient';
import { DiagnosisMetersReadDTO, DiagnosisMetersCreateDTO } from '../generated/api-client';

export const useDiagnosisMeters = () => {
  return useQuery<DiagnosisMetersReadDTO[]>('diagnosisMeters', () => apiClient.list_items_diagnosis_meters__get());
};

export const useDiagnosisMetersById = (id: string) => {
  return useQuery<DiagnosisMetersReadDTO>(
    ['diagnosisMeters', id],
    () => apiClient.get_item_diagnosis_meters__item_id__get(id),
    {
      enabled: !!id,
    }
  );
};

export const useDiagnosisMetersByDiagnosisId = (diagnosisId: string) => {
  return useQuery<DiagnosisMetersReadDTO[]>(
    `diagnosis-meters-${diagnosisId}`,
    () => apiClient.search_by_diagnosis_id_diagnosis_meters_search_by_diagnosis_id__diagnosis_id__get(diagnosisId),
    {
      enabled: !!diagnosisId,
    }
  );
};

export const useCreateDiagnosisMeters = () => {
  const queryClient = useQueryClient();

  return useMutation<DiagnosisMetersReadDTO, Error, DiagnosisMetersCreateDTO>(
    (data) => apiClient.create_item_diagnosis_meters__post(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisMeters');
        queryClient.invalidateQueries(['diagnosisMeters', 'byDiagnosisId']);
        // Invalida tutte le query che iniziano con 'diagnosis-meters-'
        queryClient.invalidateQueries({
          predicate: query => {
            const key = query.queryKey;
            if (typeof key === 'string') {
              return key.startsWith('diagnosis-meters-');
            }
            if (Array.isArray(key) && key.length > 0) {
              const firstKey = key[0];
              return typeof firstKey === 'string' && firstKey.startsWith('diagnosis-meters-');
            }
            return false;
          },
        });
      },
    }
  );
};

export const useUpdateDiagnosisMeters = () => {
  const queryClient = useQueryClient();

  return useMutation<DiagnosisMetersReadDTO, Error, { id: string; data: DiagnosisMetersCreateDTO }>(
    ({ id, data }) => apiClient.update_item_diagnosis_meters__item_id__put(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisMeters');
        queryClient.invalidateQueries(['diagnosisMeters', 'byDiagnosisId']);
        // Invalida tutte le query che iniziano con 'diagnosis-meters-'
        queryClient.invalidateQueries({
          predicate: query => {
            const key = query.queryKey;
            if (typeof key === 'string') {
              return key.startsWith('diagnosis-meters-');
            }
            if (Array.isArray(key) && key.length > 0) {
              const firstKey = key[0];
              return typeof firstKey === 'string' && firstKey.startsWith('diagnosis-meters-');
            }
            return false;
          },
        });
      },
    }
  );
};

export const useDeleteDiagnosisMeters = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, string>(
    (id) => apiClient.delete_item_diagnosis_meters__item_id__delete(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisMeters');
        queryClient.invalidateQueries(['diagnosisMeters', 'byDiagnosisId']);
        // Invalida tutte le query che iniziano con 'diagnosis-meters-'
        queryClient.invalidateQueries({
          predicate: query => {
            const key = query.queryKey;
            if (typeof key === 'string') {
              return key.startsWith('diagnosis-meters-');
            }
            if (Array.isArray(key) && key.length > 0) {
              const firstKey = key[0];
              return typeof firstKey === 'string' && firstKey.startsWith('diagnosis-meters-');
            }
            return false;
          },
        });
      },
    }
  );
};

